/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Signin_FirstInputs */

const en_billing_signin_first = /** @type {(inputs: Billing_Signin_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to buy`)
};

const id_billing_signin_first = /** @type {(inputs: Billing_Signin_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk membeli`)
};

/**
* | output |
* | --- |
* | "Sign in to buy" |
*
* @param {Billing_Signin_FirstInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_signin_first = /** @type {((inputs?: Billing_Signin_FirstInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Signin_FirstInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_signin_first(inputs)
	return en_billing_signin_first(inputs)
});